import { formatUnreadBadge } from "@shared/push-shared.ts";
import { Link } from "@tanstack/react-router";
import { BellIcon } from "../icons/index.tsx";
import { useUnreadCount } from "../lib/notifications.ts";
import { UnreadBadge, UserAvatar } from "./UserAvatar.tsx";

export function UserMenu({
  name,
  image,
  updatedAt,
  role,
}: {
  name?: string | null;
  image?: string | null;
  updatedAt?: Date | string | number | null;
  role?: string | null;
}) {
  const unread = useUnreadCount();
  const badge = formatUnreadBadge(unread);
  const bellLabel = badge ? `Notifications, ${badge} unread` : "Notifications";

  return (
    <div className="flex items-center gap-3">
      <Link to="/account" aria-label="My Account" className="inline-flex rounded-full">
        <UserAvatar
          name={name}
          image={image}
          updatedAt={updatedAt}
          role={role}
          size="md"
          decorative
        />
      </Link>
      <Link
        to="/account/notifications"
        aria-label={bellLabel}
        className="relative inline-flex items-center rounded-full p-1"
      >
        <BellIcon />
        <UnreadBadge count={unread} />
      </Link>
    </div>
  );
}
